<template>
	<div class="MainBox" @click.stop="SelectActive(-1,$self)">

    <!-- 面包屑导航 -->
    <K-Column :column="column"></K-Column>

    <!-- 表单内容 -->
    <div class="box FloatBox">
      <div class="FormStyleTwoLeft FloatBoxRow">
        <ul class="FormStyleTwo">
          <viewer @inited="inited" ref="viewer">
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>{{$t('b.Brand.BrandName')}}</p>
            <p><input :placeholder="$t('b.Brand.HintThree')" v-model="FormDatas.trademark_name" /></p>
          </li>
          <li class="FormStyleTwoRow">
            <p class="FormStyleTwoTitle"><i class="redColor">*</i>{{$t('b.Brand.Certificate')}}（{{$t('b.Brand.HintFour')}}）</p>
            <p>
              <ul class="BasicInfoOneBoxImgs">
                <li>
                  <p class="BasicInfoOneBoxImg backImg" v-if="FormDatas.trademark_cert" :style="{backgroundImage: 'url(' + FormDatas.trademark_cert + ')'}">
                    <img v-if="FormDatas.trademark_cert" class="tableImgShow" :src="FormDatas.trademark_cert" @click="PreviewImgs">
                    <span class="icon iconfont iconicon-test33 RemoveImgIcon" @click="RemoveImg(1)"></span>
                  </p>
                  <p class="BasicInfoOneBoxImg backImg" v-else></p>
                  <p class="BasicInfoOneBoxTxt">{{$t('b.Brand.BrandCertificate')}}</p>
                  <p class="BasicInfoOneBoxBtn" @click="HandleModel(1,true)">{{$t('b.Material.UploadImages')}}</p>
                </li>
                <li>
                  <p class="BasicInfoOneBoxImg backImg" v-if="FormDatas.attribute" :style="{backgroundImage: 'url(' + FormDatas.attribute + ')'}">
                    <img v-if="FormDatas.attribute" class="tableImgShow" :src="FormDatas.attribute" @click="PreviewImgs">
                    <span class="icon iconfont iconicon-test33 RemoveImgIcon" @click="RemoveImg(2)"></span>
                  </p>
                  <p class="BasicInfoOneBoxImg backImg" v-else></p>
                  <p class="BasicInfoOneBoxTxt">{{$t('b.Brand.Authorization')}}</p>
                  <p class="BasicInfoOneBoxBtn" @click="HandleModel(2,true)">{{$t('b.Material.UploadImages')}}</p>
                </li>
              </ul>
            </p>
          </li>
          </viewer>
        </ul>
      </div>
    </div>

    <!-- 底部按钮 -->
    <div class="btnArray formFootBtnArr">
      <a class="btnStyleTwo btnRadius blueBackColor" @click="SubmitForm()"><span class="icon iconfont iconicon-test17"></span>{{$t('c.Common.Save')}}</a>
      <a class="btnStyleTwo btnRadius cyanBackColor" href="javascript:history.back();"><span class="icon iconfont iconicon-test18"></span>{{$t('c.Common.Back')}}</a>
    </div>

    <!-- 图片空间 -->
    <K-ImagePicker ref="imgPicker" :show-entry="false" @change="selectImg"></K-ImagePicker>

    <!-- loading -->
    <K-Loading v-if="loading"></K-Loading>

    <!-- toast -->
    <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    <!-- 确认框 -->
    <K-Confirm :Confirm="Confirm" @ConfirmBackFun="ConfirmBackFun"></K-Confirm>

	</div>
</template>

<script>
var self;
import axios from 'axios'
import Paging from '@/components/common/Paging.vue'
import Column from '@/components/common/Column.vue'
import Transition from '@/components/common/Transition.vue'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
import Confirm from '@/components/common/Confirm.vue'
import ImagePicker from '@/components/common/ImagePicker.vue'
export default {
  name: 'AddProcess',
  components: {
    'K-Paging': Paging,
    'K-Column': Column,
    'K-Transition': Transition,
    'K-Confirm': Confirm,
    'K-Loading': Loading,
    'K-Toast': Toast,
    'K-ImagePicker': ImagePicker
  },
  data () {
    return {
      $self:null,
      id:null,
      subHint:'数据加载中...',
      isLoding:true,
      loading:false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      Confirm:{
        state:false,
        txt:null,
        style:1
      },
      column:[
        {name:'Brand',url:'Brand'}
      ],
      FormDatas:{},
    }
  },
  created () {
    self = this;
    self.$self = this;
    axios.defaults.headers.common['token'] = localStorage.getItem("wwmxt_Token");
    if(self.$route.query.id){
      self.id = self.$route.query.id;
      self.column[1] = {name:'ChangeBrand',url:'Brand?id='+self.$route.query.id};
      self.GetData();
    }else{
      self.column[1] = {name:'AddBrand',url:'Brand'};
    }
  },
  methods: {
    HandleModel (te,status) {  //通过外部按钮触发图片空间弹窗
      self.uploadType = te;
      if (status && self.$refs.imgPicker) {
        self.$refs.imgPicker.openPicker();
      }
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ConfirmBackFun (data) {
      self.Confirm.state = data.state;
      if(data.state){
        self.Confirm.state = false;
        javascript:history.back();
      }
    },
    GetData () {
      self.loading = true;
      axios.get(self.GetServerUrl(1)+"trademark/"+self.id)
      .then(function (response){
        self.FormDatas = response.data.meta;
        self.loading = false;
      }).catch(function (error){
        self.loading = false;
        self.ToastFun(2,self.ErrorHint(error));
      })
    },
    selectImg (img) {
      if(self.uploadType == 1){
        self.$set(self.FormDatas, 'trademark_cert', img);
      }else{
        self.$set(self.FormDatas, 'attribute', img);
      }
    },
    RemoveImg (te) {
      if(te == 1){
        self.$set(self.FormDatas, 'trademark_cert', null);
      }else{
        self.$set(self.FormDatas, 'attribute', null);
      }
    },
    SubmitForm () {
      if(!self.FormDatas.trademark_name){
        self.ToastFun(2,"商标名称不能为空！");
        return;
      }
      if(!self.FormDatas.trademark_cert && !self.FormDatas.attribute){
        self.ToastFun(2,"商标证书和授权书必须有一个不能为空！");
        return;
      }

      let type = "POST";
      if(self.id){
        type = "PATCH"
        self.FormDatas.id = self.id;
      }

      self.loading = true;
      axios({
        method:type,
        url:self.GetServerUrl(1)+"trademark",
        data:self.FormDatas
      }).then(function (response) {
        self.loading = false;
        self.Confirm.style = 1;
        self.Confirm.state = true;
        self.Confirm.txt = response.data.message+"，是否确定返回列表？"
      }).catch(function (error) {
        if(self.ModelType == 1){

        }else{
          self.HandleModel(self.ModelType,false); //隐藏弹出框
        }
        self.loading = false;
        self.ToastFun(2,self.ErrorHint(error));  //弹窗提醒
      })
    },
    inited (viewer) {
      self.$viewer = viewer
    },
    PreviewImgs () {
      self.$viewer.show();
      self.$viewer.update();
    }
  }
}
</script>

<style scoped>

</style>
